export enum SeatOrientation
{
    Left,
    Top,
    Right,
    None
} 